var map = {
	"./automatically-credit-player-activity/activity-assignment.ts": "app/views/plugins/workflow-activities/automatically-credit-player-activity/activity-assignment",
	"./base-activity-configuration.ts": "./ClientApp/app/views/plugins/workflow-activities/base-activity-configuration.ts",
	"./base-workflow-activity-assignment.ts": "./ClientApp/app/views/plugins/workflow-activities/base-workflow-activity-assignment.ts",
	"./brand-admin-activity/activity-assignment.ts": "app/views/plugins/workflow-activities/brand-admin-activity/activity-assignment",
	"./credit-player-activity/activity-assignment.ts": "app/views/plugins/workflow-activities/credit-player-activity/activity-assignment",
	"./credited-to-player-confirmation-activity/activity-assignment.ts": "app/views/plugins/workflow-activities/credited-to-player-confirmation-activity/activity-assignment",
	"./insurer-activity/activity-assignment.ts": "app/views/plugins/workflow-activities/insurer-activity/activity-assignment",
	"./platform-admin-activity/activity-assignment.ts": "app/views/plugins/workflow-activities/platform-admin-activity/activity-assignment",
	"./platform-admin-threshold-activity/activity-assignment.ts": "app/views/plugins/workflow-activities/platform-admin-threshold-activity/activity-assignment"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./ClientApp/app/views/plugins/workflow-activities sync recursive \\.ts$";